import { ReactNode } from 'react'

import styled from '@emotion/styled'

import { ArcadeButton } from '@cash-design-system/react'

import { useLogout } from './logout'

const ErrorBanner = styled.div`
  background-color: ${({ theme }) => theme.colors.bannerTextError};
  border-radius: 0.5rem;
  color: ${({ theme }) => theme.colors.bannerBackgroundError};
  max-width: 28rem;
  padding: ${({ theme }) => theme.spacing.m};
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 100;
`

const BannerText = styled.p`
  margin: 0;
`

const BannerActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.xs};
  justify-content: flex-start;
  margin-top: ${({ theme }) => theme.spacing.xs};
`

const BannerActionButton = styled(ArcadeButton)`
  span {
    padding-left: ${({ theme }) => theme.spacing.s};
    padding-right: ${({ theme }) => theme.spacing.s};
  }
`

const LogoutButton = styled(BannerActionButton)`
  span {
    background-color: ${({ theme }) => theme.colors.bannerBackgroundError};
    color: ${({ theme }) => theme.colors.bannerTextError};
  }

  &:hover span,
  &:active span {
    background-color: ${({ theme }) => theme.colors.bannerBackgroundError};
    color: ${({ theme }) => theme.colors.bannerTextError};
  }
`

const ReloadButton = styled(BannerActionButton)`
  span {
    background-color: transparent;
    color: ${({ theme }) => theme.colors.bannerBackgroundError};
  }

  &:hover span,
  &:active span {
    background-color: transparent;
    color: ${({ theme }) => theme.colors.bannerBackgroundError};
  }
`

// this is an internal development tool, and doesn't need to be translated
/* eslint-disable i18next/no-literal-string */
export const DevelopmentBanner = ({ children }: { children: ReactNode }) => {
  const logout = useLogout()

  return (
    <>
      {children}
      <ErrorBanner>
        <BannerText>
          GetProfile returned 401, so we could not verify your session. Log out to reset authentication, or reload to
          try again.
        </BannerText>
        <BannerActions>
          <LogoutButton size="compact" prominence="prominent" onClick={() => logout({ returnToSameUrl: true })}>
            Logout
          </LogoutButton>
          <ReloadButton size="compact" prominence="standard" onClick={() => window.location.reload()}>
            Reload
          </ReloadButton>
        </BannerActions>
      </ErrorBanner>
    </>
  )
}
/* eslint-enable i18next/no-literal-string */
